import API from '@/views/Fdc/Apis/'
import _ from 'lodash'
import Dayjs from 'dayjs'
// import Dygraph from '@/components/Dygraphs/Dygraph.vue'
import BriqueChart from '@/components/BriqueChart/BriqueChart.js'
// import Plotly from 'plotly.js-dist'

/**
 * components > Trend Analysis Chart component
 */
export default {
  name: 'TrendAnalysisChart',
  components: {
    // 'fdc-dygraphs': Dygraph // dyGraph component
  },
  props: {
    /**
     * analysisObj
     * 형식 아래 참조
     *  {
          fromDate: 검색 시작 시간 (YYYYMMDD),
          toDate: 검색 종료 시간 (YYYYMMDD),
          fromTime: 검색 시작 시간 (HHmm),
          toTime: 검색 종료 시간 (HHmm),
          reqParam: [
            {
              fabId: '',
              eqpId: '',
              moduleId: ''
            }
          ],
          paramName: ['paramName', 'paramName'],
          lotId: ['lotId', 'lotId'],
          reqParamName: [
            {
              fab: '',
              eqpId: '',
              moduleId: '',
              paramName: ''
            }
          ]
        }
     */
    trendAnalysisObj: {
      type: Object,
      default: null
    },
    /**
     * Chart Title
     */
    chartTitle: {
      type: String,
      default: ''
    },
    /**
     * Chart Title Icon
     */
    useTitleIcon: {
      type: Boolean,
      default: false
    },
    /**
     * Detection Model이 있는 Parameter 목록 배열
     */
    specOptParamList: {
      type: Array,
      default: () => []
    },
    /**
     * chart click method
     */
    chartOnClick: {
      type: Function,
      default: () => {}
    }
  },
  watch: {
    graphData (data) {
      let traces = []
      for (let i = 0; i < data.length; i++) {
        switch (this.currentChartKind) {
          case 'LOT':
          case 'SUBSTRATE':
            this.bindingXType === 'INDEX' ? data.map((e, i) => i) : data[i].x = data[i].x.map(e => {
              var date = new Date(e)
              // time zone 때문에 09:00 부터 시간이 시작되므로 offset을 더해준다.
              date.setMinutes(date.getMinutes() + date.getTimezoneOffset())
              return date
              // return Dayjs('1970-01-01 ' + Dayjs(date).format('HH:mm:ss.SSS'))
              // Dayjs('1970-01-01 ' + this.valueFormatter(e)).toDate()
            })
            break
          default:
            this.bindingXType === 'INDEX' ? data.map((e, i) => i) : data[i].x = data[i].x.map(e => Dayjs(e).toDate())
            break
        }
        if (this.bindingXType !== 'INDEX') {
          data[i].hovertemplate = '<b>Time:</b>%{x}<br><b>LOT ID:</b> %{text.lotId}<br><b>Substrate:</b> %{text.substId}<br><b>Recipe:</b> %{text.recipeId}<br><b>Step:</b> %{text.stepId}<br><b>Parameter:</b> %{text.paramName}<br><b>Value:</b> %{y:.4f}'
        } else {
          data[i].hovertemplate = '<b>Index:</b>%{x:,}<br><b>LOT ID:</b> %{text.lotId}<br><b>Substrate:</b> %{text.substId}<br><b>Recipe:</b> %{text.recipeId}<br><b>Step:</b> %{text.stepId}<br><b>Parameter:</b> %{text.paramName}<br><b>Value:</b> %{y:.4f}'
        }
        // if (['USL', 'LSL'].includes(data[i].name)) {
        //   data[i].connectgaps = false
        //   data[i].line = { color: 'red' }
        // }
        // if (['UCL', 'LCL'].includes(data[i].name)) {
        //   data[i].connectgaps = false
        //   data[i].line = { color: 'orange' }
        // }
        traces.push(data[i])
      }

      // for (let i = 1; i < this.labels.length; i++) {
      //   let x = []
      //   let y = []
      //   switch (this.currentChartKind) {
      //     case 'LOT':
      //     case 'SUBSTRATE':
      //       x = data.map(e => Dayjs('1970-01-01 ' + this.valueFormatter(e[0])).toDate())
      //       y = data.map(e => e[i] === null ? NaN : e[i])
      //       break
      //     default:
      //       x = data.map(e => Dayjs(e[0]).toDate())
      //       y = data.map(e => e[i])
      //       break
      //   }
      //   let trace = {
      //     name: this.labels[i],
      //     connectgaps: ['USL', 'LSL', 'UCL', 'LCL'].includes(this.labels[i]) === false,
      //     x: this.bindingXType === 'INDEX' ? data.map((e, i) => i) : x,
      //     y: y
      //     // 필요시 넣기 (marker 표시, marker 사이즈 조절)
      //     // type: 'scatter',
      //     // mode: 'lines+markers',
      //     // marker: {
      //     //   size: 3
      //     // }
      //   }
      //   if (['USL', 'LSL'].includes(this.labels[i])) trace.line = { color: 'red' }
      //   if (['UCL', 'LCL'].includes(this.labels[i])) trace.line = { color: 'orange' }
      //   traces.push(trace)
      // }
      let layout = {
        xaxis: {
          // rangeslider: {}
        },
        hovermode: 'closest',
        hoverlabel: {
          namelength: -1,
          align: 'left'
        },
        showlegend: true,
        legend: {
          orientation: 'h',
          y: 1.2
        },
        annotations: []
      }

      if (this.bindingXType !== 'INDEX') {
        layout.xaxis.tickformat = this.currentChartKind === 'TIME' ? '%m/%d %H:%M:%S.%3f' : '%H:%M:%S.%3f'
      }
      const config = {
        responsive: true,
        scrollZoom: true,
        displaylogo: false,
        displayModeBar: true
      }
      const briqueChartOption = {
        legend: {
          position: 'right'
        }
      }
      BriqueChart.newPlot('plotlyChart', traces, layout, config, briqueChartOption).then(() => {
        let chart = document.querySelector('#plotlyChart')
        chart.on('plotly_click', event => {
          this.chartOnClick(
            event.points[0].data.name,
            this.bindingXType === 'INDEX' ? event.points[0].pointIndex : event.points[0].x,
            event.points[0])
        })
      })
    },
    // trendAnalysisObj (value) {
    //   // this.analysisObj = value
    // },
    /**
     * currentChartKind 변화 감지
     * @param {*} kind chart option (TIME, LOT, SUBSTRATE)
     */
    currentChartKind (kind) {
      this.chartVisibleSet(kind)
    },
    /**
     * stepCount 변화 감지
     */
    stepCount () {
      this.clickSub()
    },
    /**
     * bindingXType 변화 감지
     * @param {*} type chart x type (TIME, INDEX)
     */
    bindingXType (type) {
      setTimeout(() => {
        this.isLoading = true
      }, 100)
      if (type === 'DATE') {
        // this.graphData = this.chartDataList
        if (this.labels.length > 0) {
          this.graphData = this.originGraphData
        } else {
          this.graphData = this.chartDataList
        }
      } else if (type === 'INDEX') {
        let graphData = []
        this.originGraphData = _.clone(this.graphData)
        this.graphData.forEach(item => {
          let count = 0
          let tempItem = _.clone(item)
          let tempX = []
          for (var i = 0; i < tempItem.x.length; i++) {
            tempX.push(count)
            count++
          }
          tempItem.x = tempX
          graphData.push(tempItem)
        })
        this.graphData = graphData
      }
    }
    /**
     * labels 변화 감지
     * @param {*} value chart series 목록
     */
    // labels (value) {
    //   let seriesList = []
    //   for (let i = 0; i < value.length; i++) {
    //     if (i > 0) {
    //       seriesList.push(i - 1)
    //     }
    //   }
    //   this.seriesGroup = seriesList
    // },
    /**
     * chartMainType 변화감지 (DISABLED, NORMAL, TREND)
     */
    // chartMainType (data) {
    //   this.setChartLayout(data)
    //   // if (this.chartLib === 'DYGRAPH') {
    //   //   this.setRangeSelectorHeight()

    //   //   setTimeout(() => {
    //   //     this.graphKey = this.graphKey + 1
    //   //   }, 10)

    //   //   setTimeout(() => {
    //   //     this.changeShow()
    //   //   }, 10)
    //   // }
    // }
  },
  computed: {
    /**
     * trendAnalysisObj변화 시 anlysisObj 데이터 바인딩
     * @returns {Object} trendAnalysisObj
     */
    analysisObj: function () {
      return this.trendAnalysisObj
    }
  },
  methods: {
    /**
     * Chart Option 표시 여부 설정
     * @param {*} kind currentChartKind
     */
    chartVisibleSet (kind) {
      // TIME 차트일 경우
      if (kind === 'TIME') {
        this.stepCount = 'ALL'
        this.radioDisabled = false // radio 버튼 활성화
        this.stepDisabled = true
        this.stepExpanded = false
      } else {
        this.radioDisabled = true // radio 버튼 잠금
        if (kind === 'LOT') {
          this.stepCount = 'ALL'
          this.stepDisabled = true
          this.stepExpanded = false
        } else {
          this.stepDisabled = false
          this.stepExpanded = true
        }
      }
    },
    /**
     * Chart 조회 (초기 조회 시)
     */
    getDataInitial () {
      // this.chartLib = 'DYGRAPH'
      setTimeout(() => {
        this.getData()
      }, 100)
    },
    /**
     * Chart Option 초기화 및 Chart Data 조회
     */
    getData () {
      this.currentChartKind = 'TIME'
      this.bindingXType = 'DATE'
      this.chartMainType = 'NORMAL'
      this.selectedParameter = null
      this.selectedFdModel = null
      this.specFdModelList = []

      // if (this.chartLib === 'DYGRAPH') this.setRangeSelectorHeight()

      if (this.specOptParamList.length === 0) {
        this.getMultipleParamList(this.analysisObj.reqParam)
      } else {
        this.specParamList = this.specOptParamList
      }

      this.getTrendAnalysis('TIME')
    },
    /**
     * Parameter 목록 조회 (Multi Module)
     * @param {Array} moduleList check된 Module 정보 배열
     */
    async getMultipleParamList (moduleList) {
      let fabList = []
      let eqpIdList = []
      let moduleIdList = []

      moduleList.forEach(data => {
        fabList.push(data.fabId)
        eqpIdList.push(data.eqpId)
        moduleIdList.push(data.moduleId)
      })

      let obj = {
        fab: fabList + '',
        eqpId: eqpIdList + '',
        moduleId: moduleIdList + '',
        'useYn': 'Y'
      }

      let response = await API.BaseInfo.getEqpsParams(obj)

      let specParamList = []
      for (let param of response) {
        for (let data of this.analysisObj.reqParamName) {
          if (param.fab === data.fab &&
            param.eqpId === data.eqpId &&
            param.moduleId === data.moduleId &&
            param.paramName === data.paramName &&
            param.specYn === 'Y') {
            specParamList.push(param)
          }
        }
      }

      this.specParamList = specParamList
    },
    /**
     * Chart Data 조회
     * @param {*} orderType TIME/LOT/SUBSTRATE
     */
    async getTrendAnalysis (orderType) {
      let stepIdList = []
      if (this.stepCount !== 'ALL') {
        stepIdList.push(this.stepCount)
      }

      if (this.analysisObj.reqParamName.length === 1) {
        this.lotDisabled = false
        this.substDisabled = false
      } else {
        this.lotDisabled = true
        this.substDisabled = true
      }

      let params = {
        orderType: orderType,
        fromDate: this.analysisObj.fromDate,
        toDate: this.analysisObj.toDate,
        reqParam: this.analysisObj.reqParam,
        paramName: this.analysisObj.paramName,
        stepId: stepIdList,
        lotId: this.analysisObj.lotId,
        reqParamName: this.analysisObj.reqParamName,
        chartLib: 'PLOTLY' // service level에서의 구분을 위한 추가
      }

      // this.isLoading = true

      await API.Analysis.getTraceDatas(params).then(traceParamData => {
        // let yMin = traceParamData.minValue
        // let yMax = traceParamData.maxValue
        // this.yMin = yMin
        // this.yMax = yMax
        // this.valueRange = [(yMin - ((yMax - yMin) * 0.1)), (yMax + ((yMax - yMin) * 0.1))]
        // this.labels = [...traceParamData.chartLabelList]
        this.chartDataList = [...traceParamData.chartDataList]
        // this.chartLabels = [...traceParamData.chartLabelList]

        this.graphData = [...traceParamData.chartDataList]
        this.originGraphData = [...traceParamData.chartDataList]
        this.chartOriginalDataList = [...traceParamData.originalDataList]
      })

      // this.isLoading = false

      if (this.analysisObj.reqParam.length === 1) {
        let stepCountList = []
        stepCountList.push('99')

        let payload = {
          fab: this.analysisObj.reqParam[0].fabId,
          eqpId: this.analysisObj.reqParam[0].eqpId,
          moduleId: this.analysisObj.reqParam[0].moduleId,
          useYn: 'Y',
          recipeId: 'ALL'
        }

        let planedSmryRecipe = await API.BaseInfo.getEqpRecipeSteps(payload)
        planedSmryRecipe.forEach((item) => {
          if (!stepCountList.includes(item.stepId)) {
            stepCountList.push(item.stepId)
          }
        })
        stepCountList.sort()
        this.stepCounts = stepCountList
      }
    },
    /**
     * Radio Button (TIME) click event
     * TIME으로 option을 설정하여 Chart Data를 조회합니다.
     */
    clickTime () {
      this.bindingXType = 'DATE'
      this.getTrendAnalysis('TIME')
    },
    /**
     * Radio Button (LOT) click event
     * LOT으로 option을 설정하여 Chart Data를 조회합니다.
     */
    clickLot () {
      this.bindingXType = 'DATE'
      this.getTrendAnalysis('LOT')
      this.selectedFdModel = null
    },
    /**
     * Radio Button (SUBSTRATE) click event
     * SUBSTRATE로 option을 설정하여 Chart Data를 조회합니다.
     */
    clickSub () {
      this.bindingXType = 'DATE'
      this.getTrendAnalysis('SUBSTRATE')
      this.selectedFdModel = null
    },
    // resetData () {
    //   this.$emit('trend-analysis-modal-visible', false)
    //   this.isLoading = false
    //   this.selectedParameter = null
    //   this.specParamList = []
    //   this.selectedFdModel = null
    // },
    /**
     * dyGraph x label formatter 적용
     * @param {*} x chart x value
     * @returns {*} format 적용된 x label value
     */
    axisXLabelFormatter (x) {
      if (this.bindingXType === 'DATE') {
        if (this.currentChartKind === 'TIME' && this.bindingXType === 'DATE') {
          var da = new Date(x)
          return Dayjs(da).format('MM/DD HH:mm:ss')
        } else {
          var date = new Date(x)
          // time zone 때문에 09:00 부터 시간이 시작되므로 offset을 더해준다.
          date.setMinutes(date.getMinutes() + date.getTimezoneOffset())
          return Dayjs(date).format('HH:mm:ss')
        }
      } else if (this.bindingXType === 'INDEX') {
        return x
      }
    },
    /**
     * dyGraph x value formatter 적용
     * @param {*} x chart x value
     * @returns {*} format 적용된 x value
     */
    valueFormatter (x) {
      if (this.bindingXType === 'DATE') {
        if (this.currentChartKind === 'TIME' && this.bindingXType === 'DATE') {
          var da = new Date(x)
          return Dayjs(da).format('MM/DD HH:mm:ss.SSS')
        } else {
          var date = new Date(x)
          // time zone 때문에 09:00 부터 시간이 시작되므로 offset을 더해준다.
          date.setMinutes(date.getMinutes() + date.getTimezoneOffset())
          return Dayjs(date).format('HH:mm:ss.SSS')
        }
      } else if (this.bindingXType === 'INDEX') {
        return x
      }
    },
    /**
     * Chart 영역 resize event
     */
    resized () {
      window.dispatchEvent(new Event('resize'))
      // if (this.graphData.length > 0 && this.chartLib === 'DYGRAPH') {
      //   this.graphKey = this.graphKey + 1

      //   setTimeout(() => {
      //     this.changeShow()
      //   }, 1)

      //   this.setRangeSelectorHeight()
      // }
    },
    /**
     * dyGraph Option 설정
     * @param {Number} idx chart series index
     * Chart 영역 resize 시 chart가 refresh 될 때 기존 option을 유지시켜줍니다.
     */
    // changeShow (idx) {
    //   // if (idx) {
    //   //   if (this.seriesGroup.includes(idx)) {
    //   //     this.$refs.dyGraphs.g.setVisibility(idx, true)
    //   //   } else {
    //   //     this.$refs.dyGraphs.g.setVisibility(idx, false)
    //   //   }
    //   // } else {
    //   //   let index = 0
    //   //   this.labels.forEach(() => {
    //   //     if (index !== 0) {
    //   //       if (this.seriesGroup.includes(index - 1)) {
    //   //         this.$refs.dyGraphs.g.setVisibility(index - 1, true)
    //   //       } else {
    //   //         this.$refs.dyGraphs.g.setVisibility(index - 1, false)
    //   //       }
    //   //     }
    //   //     index += 1
    //   //   })
    //   // }

    //   // let dataRange = this.$refs.dyGraphs.g.yAxisExtremes()[0]
    //   // let yMin = dataRange[0]
    //   // let yMax = dataRange[1]

    //   // let valueRange = [(yMin - ((yMax - yMin) * 0.1) + 0.0), (yMax + ((yMax - yMin) * 0.1) + 0.0)]

    //   // setTimeout(() => {
    //   //   this.$refs.dyGraphs.g.updateOptions({ valueRange: valueRange })
    //   // }, 1)
    // },
    /**
     * Chart Main Type에 따른 dyGraph 처리
     * TREND / NORMAL / DISABLED 별로 Range Selector height를 조절합니다.
     */
    // setRangeSelectorHeight () {
    //   let chartHeight = document.getElementById('dyGraphs').offsetHeight
    //   let rangeSelectorHeight = chartHeight / 2

    //   if (this.chartMainType === 'TREND') {
    //     this.rangeSelectorHeight = Math.round(rangeSelectorHeight * 10000) / 10000.0
    //     this.rangeSelectorShow = true
    //   } else if (this.chartMainType === 'NORMAL') {
    //     this.rangeSelectorHeight = 30
    //     this.rangeSelectorShow = true
    //   } else if (this.chartMainType === 'DISABLED') {
    //     this.rangeSelectorHeight = 0
    //     this.rangeSelectorShow = false
    //   }
    // },
    /**
     * Display Spec Parameter Name change event
     * 변경 시 Fault Detection Model을 조회합니다.
     */
    async fdModelSearch () {
      // fdModel combobox 초기화 및 spec line 초기화
      this.selectedFdModel = null
      this.fdModelSelect()
      if (this.selectedParameter !== null) {
        let payload = {
          fab: this.selectedParameter.fab,
          eqpId: this.selectedParameter.eqpId,
          moduleId: this.selectedParameter.moduleId,
          paramName: this.selectedParameter.paramName
        }
        let response = await API.Model.getModelParams(payload)
        this.specFdModelList = response
        if (this.specFdModelList.length > 0) {
          this.selectedFdModel = this.specFdModelList[0]
          this.fdModelSelect()
        }
      } else {
        this.specFdModelList = []
      }
    },
    /**
     * Fault Detection Model change event
     * 변경 시 선택한 Fault Detection Model에 대한 spec line을 chart에 표시합니다.
     */
    fdModelSelect () {
      if (this.selectedFdModel !== null) {
        let param = this.selectedParameter
        let fdModel = this.selectedFdModel
        let originalDataList = _.clone(this.chartOriginalDataList)
        let paramDatas = originalDataList.filter(element => (
          element.fabId === param.fab &&
          element.eqpId === param.eqpId &&
          element.moduleId === param.moduleId &&
          element.paramName === param.paramName))
        let chartData = _.clone(this.chartDataList)
        let remakeChartData = []
        let labels = this.chartLabels

        // let yRanges = this.valueRange
        // let yMin = yRanges[0]
        // let yMax = yRanges[1]

        // fdDatas를 1개의 list로 병합
        let remakeFdDatas = []
        for (let data of paramDatas) {
          let fdDatas = JSON.parse(data.fdDatas)
          remakeFdDatas.push(...fdDatas)
        }

        // let seriesIdx = this.labels.indexOf(this.selectedParameter.eqpId + '-' + this.selectedFdModel.moduleId + '-' + this.selectedParameter.paramName)
        // let totalIdx = 0
        // let fdDataIdx = 0

        let uslTrace = {
          name: 'USL',
          connectgaps: false,
          line: { color: 'red' }
        }
        let uclTrace = {
          name: 'UCL',
          connectgaps: false,
          line: { color: 'orange' }
        }
        let lclTrace = {
          name: 'LCL',
          connectgaps: false,
          line: { color: 'orange' }
        }
        let lslTrace = {
          name: 'LSL',
          connectgaps: false,
          line: { color: 'red' }
        }

        for (let data of chartData) {
          if (data.name === this.selectedParameter.eqpId + '-' + this.selectedFdModel.moduleId + '-' + this.selectedParameter.paramName) {
            let dataX = _.clone(data.x)
            let dataText = _.clone(data.text)
            let specX = []
            let specText = []
            let uslY = []
            let uclY = []
            let lclY = []
            let lslY = []
            for (var i = 0; i < dataX.length; i++) {
              let fdData = remakeFdDatas[i]
              if (!_.isEmpty(fdData)) {
                let fdModelSpec = fdData.filter(element => (element.fdModel === fdModel.paramName && element.fdType === fdModel.uvaType))
                if (fdModelSpec.length > 0) {
                  // spec data setting
                  uslY.push(parseFloat(fdModelSpec[0].fdSpec.usl))
                  uclY.push(parseFloat(fdModelSpec[0].fdSpec.ucl))
                  lclY.push(parseFloat(fdModelSpec[0].fdSpec.lcl))
                  lslY.push(parseFloat(fdModelSpec[0].fdSpec.lsl))
                  specX.push(dataX[i])
                  specText.push(dataText[i])
                } else {
                  uslY.push(null)
                  uclY.push(null)
                  lclY.push(null)
                  lslY.push(null)
                  specX.push(dataX[i])
                  specText.push(dataText[i])
                }
              } else {
                uslY.push(null)
                uclY.push(null)
                lclY.push(null)
                lslY.push(null)
                specX.push(dataX[i])
                specText.push(dataText[i])
              }
            }
            remakeChartData.push(data)

            uslTrace.x = specX
            uslTrace.y = uslY
            uslTrace.text = specText
            remakeChartData.push(uslTrace)
            uclTrace.x = specX
            uclTrace.y = uclY
            uclTrace.text = specText
            remakeChartData.push(uclTrace)
            lclTrace.x = specX
            lclTrace.y = lclY
            lclTrace.text = specText
            remakeChartData.push(lclTrace)
            lslTrace.x = specX
            lslTrace.y = lslY
            lslTrace.text = specText
            remakeChartData.push(lslTrace)
          } else {
            remakeChartData.push(data)
          }
        }

        // for (let data of chartData) {
        //   let arr = [...chartData[totalIdx]]
        //   if (this.bindingXType === 'INDEX') {
        //     arr.splice(0, 1, totalIdx)
        //   }
        //   if (data[seriesIdx] === null) {
        //     arr.push(null)
        //     arr.push(null)
        //     arr.push(null)
        //     arr.push(null)
        //   } else {
        //     let fdData = remakeFdDatas[fdDataIdx]
        //     if (fdData === null || fdData === undefined) {
        //       arr.push(null)
        //       arr.push(null)
        //       arr.push(null)
        //       arr.push(null)
        //     } else {
        //       let fdModelSpec = fdData.filter(element => (element.fdModel === fdModel.paramName && element.fdType === fdModel.uvaType))
        //       if (fdModelSpec.length > 0) {
        //         arr.push(parseFloat(fdModelSpec[0].fdSpec.usl))
        //         arr.push(parseFloat(fdModelSpec[0].fdSpec.lsl))
        //         arr.push(parseFloat(fdModelSpec[0].fdSpec.ucl))
        //         arr.push(parseFloat(fdModelSpec[0].fdSpec.lcl))

        //         if (yMax < parseFloat(fdModelSpec[0].fdSpec.usl)) {
        //           yMax = parseFloat(fdModelSpec[0].fdSpec.usl)
        //         }
        //         if (yMin > parseFloat(fdModelSpec[0].fdSpec.lsl)) {
        //           yMin = parseFloat(fdModelSpec[0].fdSpec.lsl)
        //         }
        //       } else {
        //         arr.push(null)
        //         arr.push(null)
        //         arr.push(null)
        //         arr.push(null)
        //       }
        //     }
        //     fdDataIdx++
        //   }
        //   remakeChartData.push(arr)
        //   totalIdx++
        // }

        // let valueRange = [(yMin - ((yMax - yMin) * 0.1) + 0.0), (yMax + ((yMax - yMin) * 0.1) + 0.0)]

        // label에 usl, lsl 추가
        if (labels.findIndex(element => element === 'USL') === -1) labels.push('USL')
        if (labels.findIndex(element => element === 'UCL') === -1) labels.push('UCL')
        if (labels.findIndex(element => element === 'LCL') === -1) labels.push('LCL')
        if (labels.findIndex(element => element === 'LSL') === -1) labels.push('LSL')
        this.labels = labels
        // chartdata에 spec 추가
        if (this.bindingXType === 'INDEX') {
          let graphData = []
          remakeChartData.forEach(item => {
            let count = 0
            let tempItem = _.clone(item)
            let tempX = []
            for (var i = 0; i < tempItem.x.length; i++) {
              tempX.push(count)
              count++
            }
            tempItem.x = tempX
            graphData.push(tempItem)
          })
          this.graphData = graphData
        } else {
          this.graphData = remakeChartData
        }
        this.originGraphData = remakeChartData
      } else {
        const idx = this.labels.indexOf('USL')
        if (idx > -1) this.labels.splice(idx, 1)

        const idx3 = this.labels.indexOf('UCL')
        if (idx3 > -1) this.labels.splice(idx3, 1)

        const idx4 = this.labels.indexOf('LCL')
        if (idx4 > -1) this.labels.splice(idx4, 1)

        const idx2 = this.labels.indexOf('LSL')
        if (idx2 > -1) this.labels.splice(idx2, 1)

        if (this.bindingXType === 'INDEX') {
          let graphData = []
          this.chartDataList.forEach(item => {
            let count = 0
            let tempItem = _.clone(item)
            let tempX = []
            for (var i = 0; i < tempItem.x.length; i++) {
              tempX.push(count)
              count++
            }
            tempItem.x = tempX
            graphData.push(tempItem)
          })
          this.graphData = graphData
        } else {
          this.graphData = this.chartDataList
          this.originGraphData = this.chartDataList
        }

        // if (this.chartLib === 'DYGRAPH') {
        //   // setTimeout(() => {
        //   //   this.$refs.dyGraphs.g.updateOptions({ valueRange: this.valueRange })
        //   // }, 100)
        // }
      }
    }
    /**
     * chart main type에 의한 chart option 변경
     */
    // setChartLayout (type) {
    //   var update = {}
    //   if (type === 'TREND') {
    //     update = {
    //       xaxis: {
    //         rangeslider: {
    //           thickness: 0.5
    //         }
    //       },
    //       hovermode: 'closest',
    //       showlegend: true,
    //       legend: {
    //         orientation: 'h',
    //         y: 1.2
    //       },
    //       annotations: []
    //     }
    //     if (this.bindingXType !== 'INDEX') {
    //       update.xaxis.tickformat = this.currentChartKind === 'TIME' ? '%m/%d %H:%M:%S' : '%H:%M:%S.%3f'
    //     }
    //   } else if (type === 'NORMAL') {
    //     update = {
    //       xaxis: {
    //         rangeslider: {}
    //       },
    //       hovermode: 'closest',
    //       showlegend: true,
    //       legend: {
    //         orientation: 'h',
    //         y: 1.2
    //       },
    //       annotations: []
    //     }
    //     if (this.bindingXType !== 'INDEX') {
    //       update.xaxis.tickformat = this.currentChartKind === 'TIME' ? '%m/%d %H:%M:%S' : '%H:%M:%S.%3f'
    //     }
    //   } else if (type === 'DISABLED') {
    //     update = {
    //       xaxis: {
    //         rangeslider: undefined
    //       },
    //       hovermode: 'closest',
    //       showlegend: true,
    //       legend: {
    //         orientation: 'h',
    //         y: 1.2
    //       },
    //       annotations: []
    //     }
    //     if (this.bindingXType !== 'INDEX') {
    //       update.xaxis.tickformat = this.currentChartKind === 'TIME' ? '%m/%d %H:%M:%S' : '%H:%M:%S.%3f'
    //     }
    //   }

    //   BriqueChart.relayout('plotlyChart', update)
    // }
    // chartOnClick (e, x, points) {
    //   // [2020.10.00 brique] - highlight series locked event 추가
    //   let g = this.$refs.dyGraphs.g
    //   // let flex = this.$refs.eqpLotHistoryGrid
    //   let grid = this.eqpHistoryGrid
    //   let tempRowData = this.tempRowData
    //   let self = this
    //   let chartData = this.chartDataList

    //   // console.log('g', g.yAxisRanges())
    //   // console.log('g', g.yAxisExtremes())
    //   // console.log('e', e)
    //   // console.log('x', x)

    //   // console.log('points', points)

    //   // g.updateOptions({valueRange: self.valueRange})

    //   if (g.isSeriesLocked()) {
    //     g.setAnnotations([])
    //     g.clearSelection()
    //   } else {
    //     // series selection 고정
    //     // console.log('highlight series', g.getHighlightSeries())
    //     // g.setSelection(g.getSelection(), g.getHighlightSeries(), true)

    //     // [2020.10.00] grid 시점 연동
    //     let series = g.getHighlightSeries()
    //     let seriesDatas = series.split('-')

    //     // [2020.10.00] lot Id find
    //     let lotId = null
    //     let stepId = null
    //     let originalDataList = self.chartOriginalDataList

    //     // TODO :: spec을 눌렀을 때도 시점 연동 될 수 있도록 처리!

    //     if (self.currentChartKind === 'TIME') {
    //       for (let data of originalDataList) {
    //         if (data.eqpId === seriesDatas[0] && data.moduleId === seriesDatas[1] && data.paramName === seriesDatas[2]) {
    //           var da
    //           var formatDa

    //           if (self.bindingXType === 'DATE') {
    //             da = new Date(x)
    //             formatDa = Dayjs(da).format('YYYY-MM-DD HH:mm:ss')
    //           } else if (self.bindingXType === 'INDEX') {
    //             let dataArr = chartData[x]
    //             da = new Date(dataArr[0])
    //             formatDa = Dayjs(da).format('YYYY-MM-DD HH:mm:ss')
    //           }

    //           if (data.sampleTimes.search(formatDa) !== -1) {
    //             lotId = data.lotId
    //             let sampleTimeList = JSON.parse(data.sampleTimes)
    //             let sampleIndex = sampleTimeList.findIndex(element => element.search(formatDa) !== -1)
    //             let stepIdList = JSON.parse(data.steps)
    //             // console.log('this lot', data)
    //             // console.log('this lot', sampleTimeList)
    //             // console.log('this lot index', sampleIndex)
    //             // console.log('this lot stepId', stepIdList[sampleIndex])
    //             stepId = stepIdList[sampleIndex]
    //           }
    //         }
    //       }
    //     } else if (self.currentChartKind === 'LOT') {
    //       lotId = series
    //       // TODO :: stepId 처리
    //       for (let data of originalDataList) {
    //         if (data.lotId === lotId) {
    //           let sampleTimeList = JSON.parse(data.sampleTimes)
    //           let beforeTime = null
    //           let currentTime
    //           let j = 0
    //           let sampleIdx = null
    //           for (let sampleTime of sampleTimeList) {
    //             let strTime = sampleTime.slice(0, 19)+'.'+sampleTime.slice(-3)
    //             let time = new Date(strTime).getTime()

    //             currentTime = time
    //             if (beforeTime === null) {
    //               beforeTime = time
    //             }

    //             if ((currentTime - beforeTime) === x) {
    //               sampleIdx = j
    //             }
    //             j++
    //           }
    //           let stepIdList = JSON.parse(data.steps)
    //           stepId = stepIdList[sampleIdx]
    //         }
    //       }
    //     } else if (self.currentChartKind === 'SUBSTRATE') {
    //       lotId = seriesDatas[0]
    //       // TODO :: stepId 처리
    //       for (let data of originalDataList) {
    //         if (data.lotId === lotId) {
    //           let sampleTimeList = JSON.parse(data.sampleTimes)
    //           let beforeTime = null
    //           let currentTime
    //           let j = 0
    //           let sampleIdx = null
    //           for (let sampleTime of sampleTimeList) {
    //             let strTime = sampleTime.slice(0, 19)+'.'+sampleTime.slice(-3)
    //             let time = new Date(strTime).getTime()

    //             currentTime = time
    //             if (beforeTime === null) {
    //               beforeTime = time
    //             }

    //             if ((currentTime - beforeTime) === x) {
    //               sampleIdx = j
    //             }
    //             j++
    //           }
    //           if (self.stepCount === 'ALL') {
    //             let stepIdList = JSON.parse(data.steps)
    //             stepId = stepIdList[sampleIdx]
    //           }
    //         }
    //       }
    //     }

    //     let rowIdx = null
    //     for (let i = 0; i < grid.rows.length; i++) {
    //       // console.log(grid.rows[i])
    //       if (grid.rows[i].dataItem && grid.rows[i].dataItem.lotId === lotId) {
    //         rowIdx = grid.rows[i].dataIndex
    //       }
    //     }
    //     // console.log('rowIdx', rowIdx)
    //     if (rowIdx === null) {
    //       let pageCnt = 1
    //       for (let i = 0; i < tempRowData.length; i++) {
    //         if (tempRowData[i].lotId === lotId) {
    //           console.log(i, tempRowData[i])
    //           rowIdx = i
    //         }
    //       }
    //       pageCnt = Math.floor(rowIdx / 10)
    //       rowIdx = rowIdx % 10
    //       // console.log(pageCnt, rowIdx)
    //       // self.paging.currentPage = pageCnt
    //       self.$refs.eqpLotHistoryGrid.changedPage(pageCnt)
    //     }

    //     // step 정보를 annotation으로 표시 (일단 TIME만 지정)
    //     if (lotId !== null && stepId !== null) {
    //       g.setAnnotations([
    //         {
    //           series: series,
    //           x: x,
    //           shortText: stepId,
    //           text: 'Lot ID : ' + lotId
    //         }
    //       ])
    //     }
    //     g.setSelection(g.getSelection(), g.getHighlightSeries(), true)

    //     console.log('rowIdx', rowIdx)
    //     setTimeout(() => {
    //       grid.scrollIntoView(rowIdx, 0)
    //       grid.select(rowIdx, 1)
    //       grid.focus()
    //     }, 10)
    //   }
    // },
  },
  data () {
    return {
      bindingXType: 'DATE', // chart x축 type (DATE, INDEX)
      radioDisabled: false, // chart x축 type radio button disable 여부
      currentChartKind: 'TIME', // chart overwrap type (TIME, LOT, SUBSTRATE)
      chartMainType: 'NORMAL', // chart display type (NORMAL, TREND, DISABLED) - dyGraph Range Slector 관련 option
      stepCount: 'ALL', // 선택된 step data
      stepCounts: [], // step combobox 목록
      stepDisabled: true, // step combobox disabled 여부
      stepExpanded: false, // step combobox 채우기 여부
      lotDisabled: true, // chart overwrap type(LOT) disabled 여부
      substDisabled: true, // chart overwrap type(SUBSTRATE) disabled 여부
      yMin: null, // chart y축 Min value
      yMax: null, // chart y축 Max value
      labels: [], // chart series 목록
      graphData: [], // chart data
      originGraphData: [], // 재생성된 chart data backup
      chartDataList: [], // chart data backup (option 변경 시 사용하여 chart data를 다시 생성합니다.)
      chartLabels: [], // chart label 목록
      chartOriginalDataList: [], // chart data
      selectedParameter: null, // 선택된 Parameter data
      specParamList: [], // spec이 있는 Parameter 목록
      selectedFdModel: null, // 선택된 Fault Detection Model
      specFdModelList: [] // 선택된 Parameter에 대한 Fault Detection Model 목록
    }
  }
}
